<template>
  <div class="main-wrapper">
    <Sidebar ref="sidebar"/>
    <div class="page-wrapper">
      <Navbar ref="navbar" @toggle-sidebar="toggleSidebar" />
      <slot />
      <Footer />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardLayout',
  data() {
    return {
      loaderStack: 0,
      loader: null,
    };
  },
  methods: {
    toggleSidebar() {
      this.$refs.sidebar.toggleSidebar();
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
  },
  components: {
    Footer: () => import('../components/Footer.vue'),
    Navbar: () => import('../components/Navbar.vue'),
    Sidebar: () => import('../components/Sidebar.vue'),
  },
};
</script>

<style lang="scss" scoped>
.sidebar-folded .page-wrapper {
  @media screen and (max-width: 991px) {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
}
.sidebar-folded .page-wrapper .navbar {
  @media screen and (max-width: 991px) {
    left: 0;
    right: 0;
    width: 100%;
  }
}
</style>
